import axios from 'axios';
import { API_BASE2 } from '../../../assets/config';

const BASE_URL = API_BASE2

const apiService = axios.create({
  baseURL: BASE_URL,
  timeout: 10000, // You can adjust the timeout as needed
});

const EmployeeService = {
  //Employee getlist ko lagi
  getList: async () => {
    // eslint-disable-next-line no-useless-catch  
    try {
      const response = await apiService.get('/Employee/GetList');
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  create: async (postData) => {
    // eslint-disable-next-line no-useless-catch
    try {
       // Your Bearer token (replace with your actual token)

       // Define the headers with the Authorization header
      console.log("error", postData);
      const response = await apiService.post('/Employee/Create', postData);
      console.log("response: ", response);
      return response.data;
    } catch (error) {
      throw error;
    }  
  },
  delete: async (id) => {
    // eslint-disable-next-line no-useless-catch
    try {
      
      console.log("error");
      const response = await apiService.delete(`/Employee/Delete?id=`+id);
      return response.data;
    } catch (error) {
      throw error;
    }  
  },
  view: async (id) => {
    console.log(id);
    // eslint-disable-next-line no-useless-catch  
    try {
       
      const response = await apiService.get(`/Employee/GetDetail?id=`+id);
      console.log('view data ', id,  JSON.stringify(response));
      console.log(response.data);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  update: async (id, updatedData) => {
    // eslint-disable-next-line no-useless-catch
    try {
      

      const response = await apiService.patch(`/Employee/Update?id=`+id, updatedData);
      return response.data; 
    } catch (error) {
      throw error;
    }
  },
  
  
  
};

export default EmployeeService;
